import {productAPiPath} from '@/utils/smePath'
import MixinFormat from '@/mixins/format'

export default {
  data() {
    return {
    }
  },
  props:{
    formData: {
      type: Object,
      default: () => ({})
    },
    smeClassId:{
      type: Number,
      default: 81
    }
  },
  mixins:[MixinFormat],
  computed: {
    productId(){
      return this.smeClassId
    },
    smeFormData(){
      return this.formData||{}
    },
    smeOptions(){
      return this[`smeOptions${this.productId}`]
    },
    basic_info(){
      let {basic_info ={}} = this.smeFormData||{}
      return basic_info
    },
    content_detail(){
      let {content_detail ={}} = this.smeFormData||{}
      return content_detail
    },
    ec_detail(){
      let {ec_detail ={}} = this.smeFormData||{}
      return ec_detail
    },
    total_area(){
      let {fl_area_of_work,fl_area_of_seat} = this.basic_info
      return Number(fl_area_of_seat) + Number(fl_area_of_work)
    },
    occ_information_list(){
      let {occ_information_list=[]} = this.ec_detail
      return occ_information_list
    },
    total_employee(){
      let total = this.occ_information_list.reduce((result,item)=>{
        result = result+Number(item.no_of_employee)
        return result
      })
      return total
    },
    public_liability(){
      return 'HK$ 10,000,000'
    },
    catering(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                {
                  name: 'Is it open for 24 hours?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.bus_hour_24)

                },
                {
                  name: 'Floor Area of Seated',
                  value: `${this.basic_info.fl_area_of_seat} sq. ft.` ,
                },
                {
                  name: 'Floor Area of Workspace',
                  value: `${this.basic_info.fl_area_of_work} sq. ft.` ,
                },
                {
                  name: 'Total Floor area',
                  value: `${this.total_area} sq. ft.` ,
                },
                {
                  name: 'No. of Seats',
                  value: `${this.basic_info.no_of_seats} sq. ft.` ,
                },
                {
                  name: 'Cook with Fire or Non-Fire Cooking?',
                  value:this.getOptionName(this.smeOptions.pl_cook_with_fire,this.basic_info.cook_with_fire_ind)
                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment) ',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind)
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    office(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                {
                  name: 'Floor Area',
                  value: `${this.basic_info.floor_area} sqft` ,
                },
                {
                  name: 'Is it a Co-Working Space?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.co_work_ind)
                },
                {
                  name: 'How is the insured premise been separated?',
                  value:this.getSMEOptionName(this.smeOptions.separated,this.basic_info.insured_separated_id)
                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind),
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    shop(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                {
                  name: 'Is it open for 24 hours?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.bus_hour_24)

                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind)
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    beauty(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                {
                  name: 'Is it open for 24 hours?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.bus_hour_24)

                },
                {
                  name: 'Floor Area',
                  value: `${this.basic_info.floor_area} sqft` ,
                },
                {
                  name: 'No. of Treatment Rooms',
                  value: `${this.basic_info.no_of_rooms}` ,
                },
                {
                  name: 'Any spa service?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.any_spa_ind)
                },
                {
                  name: 'No. of Jaccuzzi',
                  value:this.basic_info.no_of_jaccuzzi
                },
                {
                  name: 'Any body massage service?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.any_massage_ind)
                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind)
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    education(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                //todo
                {
                  name: 'Target Customers',
                  value:this.getSMEOptionName(this.smeOptions.target_customers_group,this.basic_info.tgt_cus_grp_id)

                },
                {
                  name: 'Where will the classes be conducted?',
                  value:this.getSMEOptionName(this.smeOptions.classes_conduct,this.basic_info.classes_conducted_id)
                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind)
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    hair(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                {
                  name: 'Is it open for 24 hours?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.bus_hour_24)

                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind)
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    medical(){
      return [
        {
          title: 'Basic Information',
          class:'mg-b-10',
          list:
              [
                {
                  name: 'Business Nature',//pure,
                  value:this.getSMEOptionName(this.smeOptions.business_nature,this.basic_info.bus_nature)
                },
                {
                  name: 'Is it open for 24 hours?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.bus_hour_24)

                },
                {
                  name: 'Any claim history in the past 3 years?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.claim_history_ind)
                },
                {
                  name: 'Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?',
                  value:this.getOptionName('smeYesNoOptions',this.basic_info.reject_ind)
                },
              ]
        },
        {
          title: 'Content Detail',
          isBold:true,
          list: [
            {
              name: 'What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)',
              value: `HK$ ${this.content_detail.contents_isrd}`,
            },
            {
              name: 'Any stock to be insured?',
              value:this.getOptionName('smeYesNoOptions',this.content_detail.stocks_ind)
            },
            {
              name: 'What is the sum insured of stock?',
              value: `HK$ ${this.content_detail.stocks_isrd||0}`,
              noShow:this.content_detail.stocks_ind==2
            }
          ],
        },
        {
          title:'Public Liability Details',
          isSpan:true,
          list:[
            {
              name:'Sum Insured of Public Liability',
              value: this.public_liability
            },
          ]
        },
      ]
    },
    showOCc(){
      let product_id = this.productId
      return [61,62,63,64,65,67].includes(product_id)
    },
    info(){
      return this[productAPiPath[this.productId]]
    },
  }
  ,
  watch: {
  },
  methods: {
  }
}
